import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

const SelectWithFilter = ({
  options,
  current,
  onInputChange,
  id,
  name,
  index,
  handleFormData,
  showDG,
  isDisabled,
}) => {
  const [showInfo, setShowInfo] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null); // Estado para el valor seleccionado
  const selectRef = useRef();

  useEffect(() => {
    setShowInfo(true);
    setSelectedValue(current); // Actualiza el estado cuando cambia 'current'
  }, [current]);

  const handleChange = (selectedOption) => {
    if (!isDisabled) {
      setSelectedValue(selectedOption); // Actualiza el estado con la opción seleccionada
      handleFormData({ target: { name, value: selectedOption.value } }, index);
    }
    // Llamar a showDG si está definido
    if (showDG) {
      showDG(selectedOption.value);
    }
  };

  return (
    <div>
      {showInfo && (
        <Select
          ref={selectRef}
          placeholder="Selecciona ..."
          options={options}
          value={selectedValue} // Establece el valor seleccionado aquí
          onChange={handleChange}
          onInputChange={onInputChange}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          id={id}
          name={name}
          isDisabled={isDisabled}
        />
      )}
    </div>
  );
};

export default SelectWithFilter;
